// Card definitions for the Oireachtas manage dashboard (B0). Reuses the
// existing ManageFeisGrade card icons for a consistent look. Layout per
// Devin's IA (2026-08-17): Entries / Tabulate / Print / Financial. Disabled
// cards are screens that are decided but not yet built — shown so the full
// shape of the workflow is visible (established pattern from the first B0
// version of this page).
import checkin from "../../Assets/managefeisGrade/checkin.svg";
import scoreCheckin from "../../Assets/managefeisGrade/scoreCheckin.svg";
import competitorLists from "../../Assets/managefeisGrade/competitorList.svg";
import addCompetitor from "../../Assets/managefeisGrade/addCompetitor.svg";
import publishedResults from "../../Assets/managefeisGrade/publishedResults.svg";
import print from "../../Assets/managefeisGrade/print.svg";
import results from "../../Assets/managefeisGrade/results.svg";
import nameSort from "../../Assets/managefeisGrade/nameSort.svg";
import scheduleMaker from "../../Assets/managefeisGrade/schedulemaker.svg";
import uploadComp from "../../Assets/managefeisGrade/downloadCompetitions.svg";
import mergeSplit from "../../Assets/managefeisGrade/mergesplit.svg";

export const manageOireachtasArray = [
  {
    // Devin 2026-09-26: the organizer's read-only panel, copied into admin
    mainTitle: "Organizer View",
    details: [
      {
        logo: results,
        title: "Organizer Panel",
        description: "What the organizer sees — entries, schools, money, assessments, late & unfinished",
        path: "/oireachtas/organizer-view",
      },
    ],
  },
  {
    mainTitle: "Entries",
    details: [
      {
        // card d76b3080: draw one competition at a time, check, then lock
        logo: nameSort,
        title: "Draw",
        description: "Draw each competition, check the order and round starts, then confirm and lock",
        path: "/oireachtas/draws",
      },
      {
        logo: competitorLists,
        title: "Competitions",
        description: "Every competition with its entry count — drill in for the locked order, prints and exports",
        path: "/oireachtas/draw",
      },
      {
        logo: addCompetitor,
        title: "Competitors",
        description: "All registered dancers — full comp list, mark World medal holders",
        path: "/oireachtas/competitors",
      },
      {
        // card 524449bc: stages and running order per day (organizer and admin edit it)
        logo: scheduleMaker,
        title: "Stage Schedule",
        description: "Stages and running order for each day, one card per competition round",
        path: "/oireachtas/schedule",
      },
    ],
  },
  {
    // Devin 2026-10-28: the same Adjudicators card the feis manage screen has
    // (a live event never reopens the wizard's Collaborators tab). Enter Scores
    // only accepts judges on this list.
    mainTitle: "Event",
    details: [
      {
        logo: mergeSplit,
        title: "Adjudicators",
        description: "Add or Edit Adjudicators",
        modal: "Adjudicators",
      },
    ],
  },
  {
    mainTitle: "Tabulate",
    details: [
      {
        logo: checkin,
        title: "Check-in",
        description: "Mark who actually dances, per round",
        path: "/oireachtas/check-in",
      },
      {
        // one screen, two doors (Devin 2026-10-28): straight to typing a sheet,
        // or the competition's hub
        logo: scoreCheckin,
        title: "Enter Scores",
        description: "Select a competition, round & judge — enter the sheet",
        path: "/oireachtas/tabulation",
        query: { mode: "enter" },
      },
      {
        logo: results,
        title: "View Scores",
        description: "A competition's scores by round — sign-offs, recall and results",
        path: "/oireachtas/tabulation",
      },
      {
        logo: publishedResults,
        title: "Status",
        description: "Every competition's tabulation progress — publish recalls & results as they're ready",
        path: "/oireachtas/status",
      },
      {
        // event-day job devices (card 540f21a4): tabulator laptops and stage tablets
        logo: checkin,
        title: "Event Devices",
        description: "Pair tabulator laptops and stage tablets — each with one job, ending after the event",
        path: "/job-devices",
        query: { kind: "oireachtas" },
      },
    ],
  },
  {
    mainTitle: "Print",
    details: [
      {
        logo: results,
        title: "Results",
        description: "Printed result per competition, and the full results book",
        path: "/oireachtas/print/results",
      },
      {
        logo: nameSort,
        title: "Competitor #'s",
        description: "Number cards — duplex 4-up, bare number on the front",
        path: "/oireachtas/print/number-cards",
      },
      {
        logo: print,
        title: "Check-in Sheets",
        description: "Per-competition check-in sheets, per round",
        path: "/oireachtas/print/check-in",
      },
      {
        logo: scoreCheckin,
        title: "Score Sheets",
        description: "Blank score sheets — one per judge & round, in draw order",
        path: "/oireachtas/print/score-sheets",
      },
      {
        logo: competitorLists,
        title: "Reports & Exports",
        description: "Competitor lists, rosters, reconciliation, qualifiers — CSV & PDF",
        path: "/oireachtas/reporting",
      },
    ],
  },
  {
    mainTitle: "Financial",
    details: [
      {
        logo: scheduleMaker,
        title: "Stripe Account",
        description: "Assign the payout account — checkout refuses payments without one",
        path: "/oireachtas/stripe",
      },
      {
        logo: uploadComp,
        title: "Fees",
        description: "The event's live fee set — family, assessment, late, per-competition",
        path: "/oireachtas/create",
        wizardTab: "3", // opens the wizard's Fees tab in edit mode
      },
      {
        logo: uploadComp,
        title: "Transaction History",
        description: "Every payment for this event",
        path: "/oireachtas/reporting",
        query: { view: "transactions" },
      },
    ],
  },
];
